function isFilterUsed(filter) {

    let numberOfCheckedTerms = 0;

    if (filter.options.length) {

        for (let i = 0; i < filter.options.length; i++) {

            if (filter.options[i].checked === true) {

                numberOfCheckedTerms++;

            }

        }

    }

    return numberOfCheckedTerms;

}

/*
    Our filters are an array of objects.
    Our graphQL call requires this array to be reformatted as a string:
        '[
            {
                id: 1
                terms: [2]
            },
            {
                id: 2
                terms: [3,4]
            }
        ]'
    That's what this function does!
*/
export function filtersToString(reactiveFilters) {

    const filters = JSON.parse(JSON.stringify(reactiveFilters));

    let filtersString = '[';

    if (filters.length) {

        for (let i = 0; i < filters.length; i++) {

            const numberOfCheckedTerms = isFilterUsed(filters[i]);

            if (numberOfCheckedTerms > 0) {

                filtersString += '{id: ' + filters[i].id + ', terms: [';

                let checkedTotal = 0;

                if (filters[i].options.length) {

                    for (let j = 0; j < filters[i].options.length; j++) {

                        if (filters[i].options[j].checked === true) {

                            checkedTotal++;

                            filtersString += filters[i].options[j].id;

                            if (checkedTotal === numberOfCheckedTerms) {

                                filtersString += ']}';

                            } else {

                                filtersString += ', ';

                            }

                        }

                    }

                }

            }

        }

    }

    filtersString += ']';

    return filtersString;

}
